export default function VideoPreview({ src }) {
    return (
      <div className="video-preview">
        <video
          src={src}
          controls
          preload="metadata"
          style={{ maxWidth: "100%", maxHeight: "100%" }}
        />
      </div>
    );
  }